//Today time list
export const USER_ID_TODAY_TIME_REQUEST = "USER_ID_TODAY_TIME_REQUEST";
export const USER_ID_TODAY_TIME_SUCCESS = "USER_ID_TODAY_TIME_SUCCESS";
export const USER_ID_TODAY_TIME_FAIL = "USER_ID_TODAY_TIME_FAIL";

//Month time list
export const USER_ID_MONTH_TIME_REQUEST = "USER_ID_MONTH_TIME_REQUEST";
export const USER_ID_MONTH_TIME_SUCCESS = "USER_ID_MONTH_TIME_SUCCESS";
export const USER_ID_MONTH_TIME_FAIL = "USER_ID_MONTH_TIME_FAIL";

//Prev time list
export const USER_ID_PREV_TIME_REQUEST = "USER_ID_PREV_TIME_REQUEST";
export const USER_ID_PREV_TIME_SUCCESS = "USER_ID_PREV_TIME_SUCCESS";
export const USER_ID_PREV_TIME_FAIL = "USER_ID_PREV_TIME_FAIL";

//Today All time list
export const USER_ID_TODAY_ALL_TIME_REQUEST = "USER_ID_TODAY_ALL_TIME_REQUEST";
export const USER_ID_TODAY_ALL_TIME_SUCCESS = "USER_ID_TODAY_ALL_TIME_SUCCESS";
export const USER_ID_TODAY_ALL_TIME_FAIL = "USER_ID_TODAY_ALL_TIME_FAIL";

//Today time list for report
export const USER_ID_TODAY_FOR_REPORT_TIME_REQUEST =
  "USER_ID_TODAY_FOR_REPORT_TIME_REQUEST";
export const USER_ID_TODAY_FOR_REPORT_TIME_SUCCESS =
  "USER_ID_TODAY_FOR_REPORT_TIME_SUCCESS";
export const USER_ID_TODAY_FOR_REPORT_TIME_FAIL =
  "USER_ID_TODAY_FOR_REPORT_TIME_FAIL";

//Month All time list
export const USER_ID_MONTH_ALL_TIME_REQUEST = "USER_ID_MONTH_ALL_TIME_REQUEST";
export const USER_ID_MONTH_ALL_TIME_SUCCESS = "USER_ID_MONTH_ALL_TIME_SUCCESS";
export const USER_ID_MONTH_ALL_TIME_FAIL = "USER_ID_MONTH_ALL_TIME_FAIL";
